module.exports = __webpack_public_path__ + "img/newercode.a94ec0f1.jpg";